import { Button, mergeClasses, MessageBar, MessageBarBody } from "@fluentui/react-components";
import ChevronRightIcon from "~icons/material-symbols/chevron-right";
import { useFormContext } from "react-hook-form";
import { FormField } from "../../../components/FormField";
import { useLoginFormStyles } from "../styles/LoginForm.styles";

type LoginFormProps = {
  onSubmit: (values: any) => Promise<void>;
  errors?: string;
  isDirty: boolean;
};

export const LoginForm = ({ onSubmit, errors, isDirty }: LoginFormProps) => {
  const styles = useLoginFormStyles();

  const methods = useFormContext();
  return (
    <form
      onSubmit={methods.handleSubmit(onSubmit)}
      className={mergeClasses(styles.flexColumnStyle, styles.formContainer)}
    >
      <FormField name="email" label={"email"} placeholder={"johndoe@email.com"} />
      <FormField name="password" label={"password"} type="password" placeholder={"••••••••••••••••"} />
      {errors && (
        <MessageBar layout="multiline" intent="error" shape="rounded">
          <MessageBarBody>
            <span>{errors}</span>
          </MessageBarBody>
        </MessageBar>
      )}
      <div className={styles.fullWidth}>
        <Button
          type="submit"
          shape="rounded"
          appearance="primary"
          className={mergeClasses(styles.fullWidth, styles.submitBtn)}
          disabled={!isDirty}
        >
          <span className={styles.textUpperCase}>Continue</span>{" "}
          <ChevronRightIcon className="text-[20px]"></ChevronRightIcon>
        </Button>
      </div>
    </form>
  );
};
